// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as SeedTableExtended } from '../../../assets/icons/extended/entities/seed-table.svg?react';
import { createIcons } from '../../Icon';
const SeedTableIcon = /* @__PURE__ */ createIcons('SeedTable', {
    extended: SeedTableExtended
});
SeedTableIcon.supportedTypes = ['extended'];
SeedTableIcon.category = 'entities';
export default SeedTableIcon;
